<template>
  <div class="sider-bar">
    <div class="menu-header" v-if="isTitle">
      <div class="zh-title">{{ zhTitle }}</div>
      <div class="cn-title">{{ cnTitle }}</div>
    </div>
    <div class="menu-box">
      <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        background-color="#005EFF"
        text-color="#fff"
        active-text-color="#005EFF"
        unique-opened
        @open="handleOpen"
        @close="handleClose"
        :default-active="menuId">
        <template v-for="menu in list">
          <el-menu-item :index="'' + menu.id" v-if="!menu.children || !menu.children.length" @click="$emit('menu-click', menu)">
            <i :class="menu.icon"></i>
            <span>{{ menu.name }}</span>
          </el-menu-item>
          <el-submenu :index="'' + menu.id" :key="menu.id" v-else>
            <template slot="title">
              <i :class="menu.icon"></i>
              <span>{{ menu.name }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="'' + subItem.id" v-for="subItem in menu.children" :key="subItem.id" @click="$emit('menu-click', subItem)">{{ subItem.name }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </div>
  
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MsSiderBar',
  data() {
    return {
      drawer: false
    }
  },
  computed: {
    ...mapGetters(['parentRows']),
    zhTitle() {
      return this.parentRows[0].name
    },
    cnTitle() {
      return this.parentRows[0].alias
    }
  },
  props: {
    isTitle: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => []
    },
    menuId: {
      type: [Number, String],
      default: ''
    }
  },
  methods: {
    handleOpen() {

    },
    handleClose() {

    },
    handleDrawerClose() {

    }
  }
}
</script>

<style lang="scss" scoped>
.sider-bar {
  width: 236px;
  background: #005EFF;
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  min-height: 60vh;
  overflow: hidden;
  z-index: 2;
  .menu-header {
    height: 94px;
    background: linear-gradient(45deg, rgba(255, 255, 255, 0.3), transparent);
    padding-top: 25px;
    padding-left: 40px;
    .zh-title {
      height: 30px;
      font-weight: bold;
      font-size: 22px;
      color: #FFFFFF;
      line-height: 30px;
    }
    .cn-title {
      height: 18px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 18px;
      text-transform: uppercase;
    }
  }
  .menu-box {
    padding: 30px 40px;
    ::v-deep .el-menu {
      border-right: none;
      .el-submenu .el-menu-item,
      .el-menu-item {
        min-width: 100px;
        border-radius: 4px;
        height: 40px;
        line-height: 40px;
      }
      .el-menu-item, .el-submenu__title {
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        margin-bottom: 12px;
      }
      .el-menu-item i,
      .el-submenu__title i {
        color: #fff;
      }
      .el-menu-item.is-active {
        background: #fff !important;
      }
      .el-submenu__icon-arrow {
        right: 0px;
        margin-top: -3px;
      }
    }
  }
}
</style>
